export default {
  name: 'Aconfirm',
  props: {
    text: { type: String, default: () => '删除' },
    type: { type: String, default: () => 'danger' },
    title: { type: String, default: () => '确认信息' },
    content: { type: String, default: () => '当前操作确认提示.' },
    distinguishCancelAndClose: { type: Boolean, default: () => true },
    confirmButtonText: { type: String, default: () => '确定' },
    cancelButtonText: { type: String, default: () => '取消' },
    cancelMessage: { type: String, default: () => '当前操作已取消' },
  },
  methods: {
    enable() {
      this.$confirm(this.content, this.title, {
        distinguishCancelAndClose: this.distinguishCancelAndClose,
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
      }).then(() => {
        this.$emit('finish');
        this.$emit('submit');
      }).catch(e => {
        this.$emit('cancel', e);
      });
    }
  },
  render() {
    const { ...attrs } = this.$attrs;
    return <el-button type={this.type} on-click={() => this.enable()} {...{ attrs }}>{this.text}</el-button>
  },
}